import ArtificialIntelligence from '../../assets/artificial-intelligence-collection.svg';
import AtlassianVentures from '../../assets/atlassian-ventures.svg';
import ChangeMakers from '../../assets/changemakers.svg';
export const collections = [{
  id: 'artificial-intelligence',
  title: 'Artificial intelligence',
  description: 'Elevate productivity with AI-powered apps to revolutionize your workflows.',
  image: ArtificialIntelligence,
  backgroundColor: "var(--ds-background-accent-gray-subtlest)"
}, {
  id: 'atlassian-ventures',
  title: 'Atlassian Ventures',
  description: 'Apps from Atlassian Ventures portfolio companies that focus on innovative ways for cloud collaboration.',
  image: AtlassianVentures,
  backgroundColor: "var(--ds-background-accent-gray-subtlest)"
}, {
  id: 'changemakers',
  title: 'Changemakers',
  description: 'Apps from companies that support Pledge 1%, to make a positive impact on society and the environment.',
  image: ChangeMakers,
  backgroundColor: "var(--ds-background-accent-gray-subtlest)"
}];